// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UjadiO7m6Yoqcs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 32px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .UjadiO7m6Yoqcs {
    display: block;
    margin-top: 0;
    margin-left: 0;
  }
}
.UjadiO7m6Yoqcs ul {
  padding: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .UjadiO7m6Yoqcs ul {
    padding-top: 0;
    padding-bottom: 20px;
  }
}
.HpRy67EPi4UPPs {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.HpRy67EPi4UPPs .EpJHekyvlcH0vH {
  display: inline-block;
  width: 48px;
  min-width: 48px;
  height: 48px;
  margin-right: 12px;
  border-radius: 3px;
}
.HpRy67EPi4UPPs .PkTO6yr4Oww6lr {
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  line-height: 24px;
}
.pdIqsyz_yklUGr {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-top: 31px;
}
.uW4X_qpS2WBvp2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 272px;
  padding: 25px 0 30px;
  border: 1px solid var(--ds-border, #091e4224);
  border-width: 1px 0 0;
  font-size: 12px;
}
.uW4X_qpS2WBvp2 .WAiTi3EvQ6cd7L {
  margin: 0;
}
.uW4X_qpS2WBvp2 .IT3HYEK0vReb5P {
  display: inline-block;
  width: 104px;
  min-width: 104px;
  height: 104px;
  padding-left: 25px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .uW4X_qpS2WBvp2 {
    flex-direction: column-reverse;
    padding: 25px 0;
  }
  .uW4X_qpS2WBvp2 .IT3HYEK0vReb5P {
    padding-bottom: 25px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateBreadCrumb": `UjadiO7m6Yoqcs`,
	"templateGalleryHeaderContainer": `HpRy67EPi4UPPs`,
	"templateGalleryIcon": `EpJHekyvlcH0vH`,
	"templateGalleryHeader": `PkTO6yr4Oww6lr`,
	"templatesTilesContainer": `pdIqsyz_yklUGr`,
	"categoryDescriptionContainer": `uW4X_qpS2WBvp2`,
	"categoryDescription": `WAiTi3EvQ6cd7L`,
	"categoryIcon": `IT3HYEK0vReb5P`
};
export default ___CSS_LOADER_EXPORT___;
